(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2431],{

/***/ 70234:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/launch-landing",
      function () {
        return __webpack_require__(90615);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _instanceof = (__webpack_require__(70237)/* ["default"] */ .Z);
"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadable = _interop_require_default(__webpack_require__(42060));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if ( true && loadableOptions.suspense) {
        throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 46941:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 42060:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(60616)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(90416)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(59419)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(23903)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(2784));
var _loadableContext = __webpack_require__(46941);
var useSyncExternalStore = ( false ? 0 : __webpack_require__(43100)).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            this._delay = setTimeout(function() {
                                _this._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        this._timeout = setTimeout(function() {
                            _this._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _extends({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 90615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ launch_landing; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ./components/layout/Page.tsx + 19 modules
var Page = __webpack_require__(24882);
// EXTERNAL MODULE: ./hooks/useI18n/index.ts + 1 modules
var useI18n = __webpack_require__(39105);
// EXTERNAL MODULE: ../../node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(70423);
// EXTERNAL MODULE: ./components/shared/Typography.styled.tsx
var Typography_styled = __webpack_require__(90637);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 8 modules
var esm = __webpack_require__(7621);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/polished/dist/polished.esm.js + 4 modules
var polished_esm = __webpack_require__(28870);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 1 modules
var styled_components_browser_esm = __webpack_require__(40286);
// EXTERNAL MODULE: ./utils/paths.tsx
var paths = __webpack_require__(64516);
// EXTERNAL MODULE: ./theme/index.js + 247 modules
var theme = __webpack_require__(90408);
;// CONCATENATED MODULE: ./components/marketingSite/launch/LaunchHero.styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  margin-top: -",
        ";\n  padding-bottom: ",
        ";\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: ",
        ";\n    background-color: ",
        ";\n  }\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-image: linear-gradient(\n      147deg,\n      ",
        " 0%,\n      ",
        " 70%,\n      transparent 100%\n    );\n    mix-blend-mode: hard-light;\n    z-index: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  opacity: 0.2;\n  z-index: ",
        ";\n\n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ",
        ";\n    mix-blend-mode: darken;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: black;\n    mix-blend-mode: lighten;\n  }\n\n  div {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-image: url('",
        "');\n    background-size: cover;\n    background-position: center center;\n    filter: grayscale(100%);\n    z-index: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  z-index: ",
        ";\n  text-align: center;\n  color: ",
        ";\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-top: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-size: 175%;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  height: 1.35em;\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  animation: wordSlider ease-out infinite 12s;\n\n  > span {\n    display: block;\n    line-height: 1.3em;\n    color: ",
        ";\n\n    &:nth-child(2) {\n      color: ",
        ";\n    }\n\n    &:nth-child(3) {\n      color: ",
        ";\n    }\n\n    &:nth-child(4) {\n      color: ",
        ";\n    }\n\n    &:nth-child(5) {\n      color: ",
        ";\n    }\n  }\n\n  @keyframes wordSlider {\n    0%,\n    16% {\n      transform: translateY(0%);\n    }\n    20%,\n    36% {\n      transform: translateY(-16.66%);\n    }\n    40%,\n    56% {\n      transform: translateY(-33.33%);\n    }\n    60%,\n    76% {\n      transform: translateY(-50%);\n    }\n    80%,\n    96% {\n      transform: translateY(-66.66%);\n    }\n    100% {\n      transform: translateY(-83.33%);\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var StyledHero = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-af9ff485-0"
})(_templateObject(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* zindex */.Y0)("heroBg"), (0,theme/* color */.$_)("midnight_900"), (0,theme/* color */.$_)("purple_900"), (0,polished_esm/* rgba */.m4)("#1e076e", 0.6), (0,theme/* zindex */.Y0)("heroBgGradient"));
var StyledHeroBg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-af9ff485-1"
})(_templateObject1(), (0,theme/* zindex */.Y0)("heroSectionBg"), (0,theme/* color */.$_)("emerald_500"), (0,paths/* getPublicPath */.A)("/images/launch/hero-bg.jpg"), (0,theme/* zindex */.Y0)("heroSectionBgImg"));
var StyledContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-af9ff485-2"
})(_templateObject2(), (0,theme/* zindex */.Y0)("heroContent"), (0,theme/* color */.$_)("text_white"), (0,theme/* spacing */.W0)("xl4"));
var StyledHeadingCarousel = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-af9ff485-3"
})(_templateObject3(), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledHeadingCarouselInner = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-af9ff485-4"
})(_templateObject4(), (0,theme/* color */.$_)("emerald_300"), (0,theme/* color */.$_)("sun_500"), (0,theme/* color */.$_)("negative_200"), (0,theme/* color */.$_)("indigo_300"), (0,theme/* color */.$_)("purple_100"));

;// CONCATENATED MODULE: ./components/jobOffer/hero/HeroScroll.styled.js

function HeroScroll_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  flex-direction: column;\n  align-items: center;\n  margin-top: auto;\n  padding-top: ",
        ";\n  color: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  text-transform: uppercase;\n  z-index: 1;\n\n  &:hover {\n    color: inherit;\n  }\n\n  @media (min-width: ",
        ") {\n    display: flex;\n  }\n"
    ]);
    HeroScroll_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeroScroll_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 2.5rem;\n  width: 1.5rem;\n  margin-bottom: ",
        ";\n  border-radius: ",
        ";\n  border: 2px solid;\n"
    ]);
    HeroScroll_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeroScroll_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: calc(",
        " - ",
        " / 2 - 2px);\n  left: calc(50% - ",
        " / 2);\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  background-color: ",
        ";\n  animation: ball 3.5s ease-in-out infinite;\n\n  @keyframes ball {\n    0% {\n      height: ",
        ";\n      top: calc(",
        " - ",
        " / 2 - 2px);\n    }\n    30% {\n      height: ",
        ";\n      top: calc(",
        " - ",
        " / 2 - 2px);\n      background-color: ",
        ";\n    }\n    50% {\n      height: ",
        ";\n      top: ",
        ";\n      background-color: ",
        ";\n    }\n    75% {\n      height: ",
        ";\n      top: ",
        ";\n    }\n    100% {\n      top: calc(",
        " - ",
        " / 2 - 2px);\n    }\n  }\n"
    ]);
    HeroScroll_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HeroScroll_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n\n  strong {\n    font-weight: ",
        ";\n    opacity: 0;\n    animation: appear 3.5s ease-in-out infinite;\n\n    @keyframes appear {\n      40% {\n        opacity: 0;\n      }\n      50% {\n        opacity: 1;\n      }\n      75% {\n        opacity: 1;\n      }\n      100% {\n        opacity: 0;\n      }\n    }\n  }\n"
    ]);
    HeroScroll_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var StyledHeroScroll = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-63286dff-0"
})(HeroScroll_styled_templateObject(), (0,theme/* spacing */.W0)("sm"), (0,theme/* color */.$_)("text_subtle_inverse"), (0,theme/* fontSize */.JB)("xs"), (0,theme/* fontWeight */.Ue)("medium"), (0,theme/* screen */.sp)("md"));
var StyledHeroScrollMouse = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-63286dff-1"
})(HeroScroll_styled_templateObject1(), (0,theme/* spacing */.W0)("xs"), (0,theme/* radius */.q0)("full"));
var StyledHeroScrollMouseBall = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-63286dff-2"
})(HeroScroll_styled_templateObject2(), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* radius */.q0)("full"), (0,theme/* color */.$_)("text_subtle_inverse"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* color */.$_)("active"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* color */.$_)("text_subtle_inverse"), (0,theme/* spacing */.W0)("xs2"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("sm"), (0,theme/* spacing */.W0)("xs2"));
var StyledHeroScrollText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-63286dff-3"
})(HeroScroll_styled_templateObject3(), (0,theme/* fontWeight */.Ue)("black"));

;// CONCATENATED MODULE: ./components/marketingSite/launch/LaunchHeroScroll.tsx


var LaunchHeroScroll = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroScroll, {
        href: "#manifest",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroScrollMouse, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroScrollMouseBall, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeroScrollText, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Haz scroll"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "y te contamos m\xe1s"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var launch_LaunchHeroScroll = (LaunchHeroScroll);

;// CONCATENATED MODULE: ./components/marketingSite/launch/LaunchHero.tsx





var Words = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeadingCarousel, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeadingCarouselInner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "start",
                    children: "sencillo"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: "est\xfapido"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: "simple"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: "maldito"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: "ingenuo"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    "aria-hidden": "true",
                    children: "sencillo"
                })
            ]
        })
    });
};
var LaunchHero = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHero, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeroBg, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContent, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_styled/* Heading1 */.nL, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
                        i18nKey: "hero.form",
                        ns: "launch-landing",
                        components: {
                            words: /*#__PURE__*/ (0,jsx_runtime.jsx)(Words, {})
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(launch_LaunchHeroScroll, {})
        ]
    });
};
/* harmony default export */ var launch_LaunchHero = (LaunchHero);

// EXTERNAL MODULE: ../../node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(9725);
// EXTERNAL MODULE: ../../node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(49929);
// EXTERNAL MODULE: ./components/marketingSite/shared/FaqsItem.tsx
var FaqsItem = __webpack_require__(53307);
// EXTERNAL MODULE: ./components/shared/ButtonLink.js
var ButtonLink = __webpack_require__(68692);
// EXTERNAL MODULE: ./components/shared/Typography.js
var Typography = __webpack_require__(99655);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ./utils/app-urls.ts
var app_urls = __webpack_require__(62177);
;// CONCATENATED MODULE: ./components/marketingSite/launch/LaunchNews.styled.ts

function LaunchNews_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n  margin: auto;\n  max-width: calc(",
        " + ",
        " * 2);\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  text-align: center;\n"
    ]);
    LaunchNews_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LaunchNews_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        " auto;\n  max-width: ",
        ";\n  border-bottom: 1px solid ",
        ";\n  counter-reset: faqs;\n  text-align: left;\n"
    ]);
    LaunchNews_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-42165624-0"
})(LaunchNews_styled_templateObject(), (0,theme/* color */.$_)("sand_100"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* container */.nC)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledNews = styled_components_browser_esm/* default.dl.withConfig */.ZP.dl.withConfig({
    componentId: "sc-42165624-1"
})(LaunchNews_styled_templateObject1(), (0,theme/* spacing */.W0)("xl4"), (0,theme/* container */.nC)("md"), (0,theme/* color */.$_)("midnight_200"));

;// CONCATENATED MODULE: ./components/marketingSite/launch/LaunchNews.tsx











var LaunchNews = function() {
    var t = (0,useI18n/* useI18n */.Q)("launch-landing").t;
    var locale = (0,router.useRouter)().locale;
    var news = [
        {
            // getPublicPath('/images/launch/autonomy.gif')
            active: true,
            question: t("news.autonomy.title"),
            answer: t("news.autonomy.desc", {
                img: (0,paths/* getPublicPath */.A)("/images/launch/autonomy.gif")
            })
        },
        {
            question: t("news.time.title"),
            answer: t("news.time.desc")
        },
        {
            question: t("news.security.title"),
            answer: t("news.security.desc")
        },
        {
            // getPublicPath('/images/launch/roles.gif')
            question: t("news.standard.title"),
            answer: t("news.standard.desc", {
                img: (0,paths/* getPublicPath */.A)("/images/launch/roles.gif")
            })
        },
        {
            question: t("news.sync.title"),
            answer: t("news.sync.desc")
        },
        {
            // getPublicPath('/images/launch/design.gif')
            question: t("news.design.title"),
            answer: t("news.design.desc", {
                img: (0,paths/* getPublicPath */.A)("/images/launch/design.gif")
            })
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                editorial: true,
                children: t("news.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNews, {
                children: news === null || news === void 0 ? void 0 : news.map(function(n, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqsItem/* default */.Z, {
                        question: n.question,
                        active: n.active,
                        answer: n.answer
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.login */.uu.login, locale)),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faCheckCircle */.f8k
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: t("news.cta")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var launch_LaunchNews = (LaunchNews);

;// CONCATENATED MODULE: ./components/marketingSite/launch/LaunchVideo.styled.ts

function LaunchVideo_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n\n  @media (min-width: ",
        ") {\n    padding-top: ",
        ";\n    padding-bottom: ",
        ";\n  }\n"
    ]);
    LaunchVideo_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function LaunchVideo_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  max-width: calc(",
        " + ",
        " * 2);\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n  text-align: center;\n"
    ]);
    LaunchVideo_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function LaunchVideo_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-bottom: 56.25%;\n  height: 0;\n  overflow: hidden;\n  max-width: 100%;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n\n  iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    LaunchVideo_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var StyledHow = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-50e8b07e-0"
})(LaunchVideo_styled_templateObject(), (0,theme/* color */.$_)("white"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl3"), (0,theme/* screen */.sp)("lg"), (0,theme/* spacing */.W0)("xl4"), (0,theme/* spacing */.W0)("xl4"));
var LaunchVideo_styled_StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-50e8b07e-1"
})(LaunchVideo_styled_templateObject1(), (0,theme/* container */.nC)("xl"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"), (0,theme/* spacing */.W0)("md"));
var StyledVideo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-50e8b07e-2"
})(LaunchVideo_styled_templateObject2(), (0,theme/* spacing */.W0)("xl3"), (0,theme/* spacing */.W0)("xl4"));

;// CONCATENATED MODULE: ./components/marketingSite/launch/LaunchVideo.tsx









var LaunchVideo = function() {
    var t = (0,useI18n/* useI18n */.Q)("launch-landing").t;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHow, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LaunchVideo_styled_StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Heading2 */.XJ, {
                    editorial: true,
                    children: t("manifest.title")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledVideo, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        src: "https://www.youtube.com/embed/E1KTTjgfqg8",
                        frameBorder: "0",
                        allowFullScreen: true
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonLink/* ButtonLink */.Z, {
                    href: "".concat((0,app_urls/* getAppUrl */.TI)(app_urls/* APP_URLS.login */.uu.login, locale)),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faCheckCircle */.f8k
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: t("manifest.cta")
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var launch_LaunchVideo = (LaunchVideo);

;// CONCATENATED MODULE: ./components/marketingSite/launch/LaunchComponent.tsx







var LaunchComponent = function() {
    var t = (0,useI18n/* useI18n */.Q)("launch-landing").t;
    var launchSections = [
        {
            section: "hero",
            tooltip: t("nav.hero")
        },
        {
            section: "manifest",
            tooltip: t("nav.manifest")
        },
        {
            section: "news",
            tooltip: t("nav.news")
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* default */.ZP, {
        hasScrollTop: true,
        sections: launchSections,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "inicio",
                id: "hero",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(launch_LaunchHero, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "manifest",
                id: "manifest",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(launch_LaunchVideo, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Element */.W_, {
                name: "news",
                id: "news",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(launch_LaunchNews, {})
            })
        ]
    });
};
/* harmony default export */ var launch_LaunchComponent = (LaunchComponent);

// EXTERNAL MODULE: ./hooks/usePageTrack/index.ts + 1 modules
var usePageTrack = __webpack_require__(56002);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/launch-landing.tsx





var LaunchLandingPage = function() {
    var t = (0,useI18n/* useI18n */.Q)("launch-landing").t;
    (0,usePageTrack/* usePageTrack */.N)("Landing - Page Loaded");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: t("page_title")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(launch_LaunchComponent, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var launch_landing = (LaunchLandingPage);


/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 25237:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(95805)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7482,625,4882,7265,9774,2888,179], function() { return __webpack_exec__(70234); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);